<mat-toolbar>
  <h4 mat-dialog-title style="width: 100%"></h4>
  <span class="fill-remaining-space"></span>
  <button class="btn-dialog-close" mat-raised-button (click)="onClose()" tabindex="-1">
    <mat-icon>clear</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>

    <ng-container *ngIf="loadingBodies === true">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-container>

    <ng-container *ngIf="usersBodies && usersBodies.length > 0">
      <app-user-body-list  *ngIf="loadingBodies === false && usersBodies" [userBodies]="usersBodies" [user]="user" (submit)="emitComment($event)"></app-user-body-list>
    </ng-container>

    <ng-container *ngIf="!usersBodies || usersBodies.length == 0">
      <div style="height: 20vh;">
        <p style="text-align: center; padding-top: 3rem;">
          No hay registros para mostrar
        </p>
      </div>
    </ng-container>

</mat-dialog-content>
<hr>
<!-- <mat-dialog-actions align="end">
  <button class="btn" mat-stroked-button (click)="onClose()">Cerrar Ventana</button>
</mat-dialog-actions> -->


